var editor;

$(document).on('turbolinks:load', function(){
  var selectors = ['#blog_body', '.copy_text_content_editable', '#headline_description']
  jQuery.each(selectors, function(index, selector) {
    if ($(selector).length) {
      editor = new FroalaEditor(selector, {
        key:  "",
        toolbarButtons: ['fullscreen', 'bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', '|', 'color', 'emoticons', 'inlineStyle', 'paragraphStyle', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', 'insertTable', '|', 'quote', 'insertHR', 'undo', 'redo', 'clearFormatting', 'selectAll', 'html']
      });
    }
  });
});

$(document).on('turbolinks:before-cache', function(){
  if (editor)
    editor.destroy();
});